import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './styles/blog.css';

class Blog extends Component {
  constructor() {
    super();
    this.state = { 
      blog_posts: []
    }
  }

  componentDidMount() {
    axios.all([
      axios.get(process.env.REACT_APP_API + '/api/blog/')
    ])
    .then(axios.spread((response) => {
      this.setState({blog_posts: response.data});
    }));
  }

  render() {
    console.log(this.state.blog_posts);
    const blog_posts = this.state.blog_posts ? Object.keys(this.state.blog_posts).map((slug) =>
      <div className="blog-post-preview-div col-md-4 d-flex align-items-stretch">
      <div className="box-shadow w-100">
        { this.state.blog_posts[slug].header ? <Link to={"/blog/" + slug }><img src={ process.env.PUBLIC_URL + "/media/" + this.state.blog_posts[slug].header } /></Link> : "" }
        <h2 className="title"><Link to={"/blog/" + slug }>{ this.state.blog_posts[slug].title }</Link></h2>
        <p className="date">{ this.state.blog_posts[slug].created_at }</p>
        <p className="description">{ this.state.blog_posts[slug].description }</p>
        <div className="read-more"><Link to={"/blog/" + slug }>Read more</Link></div>
      </div>
      </div>
    ) : "";
    return <div className="row">
    { blog_posts }
    </div>;
  }
}

export default Blog



// WEBPACK FOOTER //
// ./src/Blog.jsx